const saveMetadataUrl = (businessKey: string): string => {
  return `/customers/${businessKey}/update-identity`;
};

export const getMetadataDocumentsPreviewUrl = (docId: string): string => {
  return `/documents/${docId}/preview`;
};

export default saveMetadataUrl;
